import styled, { createGlobalStyle } from "styled-components";

import { Button } from "@npm-telluria-tecnologia/telluria-ui";

export const fieldMinWidth = "330px";
export const fieldWithButtonsMinWidth = "434px";

const fieldMinHeight = "65px";
const fieldControlButtonsHeight = "41px";
const maxScreenWidthWithoutOverlappingStepControls = "1606px";
const maxScreenHeightWithoutOverlappingStepControls = "940px";
const maxScreenHeightForFormInTwoLines = "780px";

export const windowWidth = {
  uhd: "2560px",
  laptop: {
    large: "1440px",
    medium: "1024px"
  },
  tablet: "768px",
  mobile: {
    large: "425px",
    medium: "375px",
    small: "320px"
  }
};

export default createGlobalStyle`

  :root {
    --brand-navy: ${(props) => props.theme.brand.navy};
    --brand-navy-med: ${(props) => props.theme.brand.navyMed};
    --brand-navy-deep: ${(props) => props.theme.brand.navyDeep};
    --brand-navy-hover: ${(props) => props.theme.brand.navyHover};
    --brand-green: ${(props) => props.theme.brand.green};
    --brand-orange: ${(props) => props.theme.brand.orange};
    --brand-gold: ${(props) => props.theme.brand.gold};
    --brand-ink: ${(props) => props.theme.brand.ink};
    --brand-muted: ${(props) => props.theme.brand.muted};
    --brand-soft: ${(props) => props.theme.brand.soft};
    --brand-line: ${(props) => props.theme.brand.line};
    --brand-bg: ${(props) => props.theme.brand.bg};
  }

  #root {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  * {
    font-family: 'Roboto', sans-serif;
    font: 'Roboto';
    padding: 0;
    margin: 0;
    box-sizing: border-box;

    .default-field {
      min-width: ${fieldWithButtonsMinWidth} !important;
      min-height: ${fieldMinHeight} !important;

      @media ( max-width: ${windowWidth.mobile.large} ) {
        min-width: 100% !important;
      }

      .MuiFormHelperText-root {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
    }
    .default-submit-button {
      background-color: ${(props) => props.theme.colors.primary} !important;
    }
    .default-delete-button {
      background-color: red !important;
    }
    .tooltip-div {
      @media ( max-width: ${windowWidth.mobile.large} ) {
        min-width: 100% !important;
      }
    }

    .MuiModal-root {
      z-index: 1300 !important;
    }
    .MuiFormHelperText-root {
      text-align: end !important;
      margin-right: 0 !important;
      margin-bottom: 10px !important;
    }

    /* width */
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgb(120,120,120);
      border-radius: 10px;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: rgb(150,150,150);
      border-radius: 10px;
    }
  }

  a {
    border: none;
    outline: none;
    text-decoration: none;
  }
`;

/** Styled components */
const FieldWithActionButtons = styled.div`
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  gap: 14px !important;
  width: ${fieldWithButtonsMinWidth} !important;
  min-width: 200px !important;
  min-height: ${fieldMinHeight} !important;
  
  @media ( max-width: ${windowWidth.tablet} ) {
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .MuiFab-primary:not(.Mui-disabled) {
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

  /* autocomplete field */
  > :first-child {
    flex-grow: 1;
  }

  .MuiFormHelperText-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
`;

const FieldActionButtons = styled.div`
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 10px !important;
  height: ${fieldControlButtonsHeight} !important;
`;

const DrawerKanbanSection = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;
  gap: 20px;

  > :first-child {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
  }

  @media ( max-width: ${windowWidth.laptop.large} ) {
    width: 280px;
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    width: 100%;

    > :first-child {
      width: 100%;
      padding-bottom: 85px;
    }
  };

  @media ( max-width: ${windowWidth.mobile.medium} ) {
    > button {
      width: 150px !important;
    }
  }

  @media ( max-width: ${windowWidth.mobile.small} ) {
    > button {
      min-width: 125px !important;
      width: 125px !important;
    }
  }
`;

const DrawerKanbanSectionActionButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.primary} !important;
  padding: 8px 10px !important;

  @media ( max-width: ${windowWidth.laptop.large} ) {
    min-height: 50px !important;
    min-width: 175px !important;

    > :first-child {
      font-size: 15px !important;
      width: 130px !important;
    }

    > :last-child {
      > .MuiButton-endIcon, .MuiButton-startIcon {
        svg {
          width: 30px !important;
          height: 30px !important;
        }
      }
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    position: fixed !important;
    left: 16px !important;
    bottom: 16px !important;
  }
`;

const DrawerKanbanSectionFormArea = styled.div`
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media ( max-width: ${windowWidth.mobile.large} ) {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    background-color: white;
  }
`;

const DrawerFormContainer = styled.form`
  max-height: 99%;
  max-width: 497px;
  overflow-y: auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.25);

  > :last-child {
    margin-top: 40px;
  }

  > * {
    .default-field {
      @media ( max-width: ${windowWidth.tablet} ) {
        min-width: 100% !important;
      }
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    padding: 15px;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }

  @media ( min-width: ${windowWidth.laptop.large} ) 
    and ( min-height: ${maxScreenHeightForFormInTwoLines}) {
      max-width: 99%;
      flex-flow: row nowrap;
      writing-mode: vertical-lr;  

      > * {
        writing-mode: horizontal-tb;
      }
  }

  @media (max-width: ${maxScreenWidthWithoutOverlappingStepControls}) 
    and (min-width: ${windowWidth.laptop.large})
    and (max-height: ${maxScreenHeightWithoutOverlappingStepControls}) {
      padding-bottom: 80px;
  }

  @media (max-width: ${windowWidth.laptop.medium}) 
    and (max-height: ${maxScreenHeightWithoutOverlappingStepControls}) {
      padding-bottom: 80px;
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    padding-bottom: 20px;
    width: 100%;
    box-shadow: none;
  }
`;

const DrawerFormFields = styled.div`
  width: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column nowrap;
  /* gap: 15px; */

  @media ( min-width: ${windowWidth.laptop.large} ) 
    and ( min-height: ${maxScreenHeightForFormInTwoLines}) {
      row-gap: 40px !important; 
      flex-flow: row wrap;
      writing-mode: vertical-lr;

      > * {
        writing-mode: horizontal-tb;
      }
  }

  @media ( max-width: ${windowWidth.laptop.large} ) {
    width: 100%;
  }

`;

const DrawerFormButtons = styled.div`
  align-self: flex-end;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;

  button {
    background-color: ${(props) => props.theme.colors.primary} !important;
    color: white !important;

    @media ( max-width: ${windowWidth.mobile.medium} ) {
      &.MuiButton-root {
        min-width: 130px !important;
        width: 130px !important;
      }
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    align-self: center;
  }
`;

const GlobalStyledComponents = {
  DrawerFormFields,
  DrawerFormButtons,
  FieldActionButtons,
  DrawerKanbanSection,
  DrawerKanbanSectionActionButton,
  DrawerFormContainer,
  FieldWithActionButtons,
  DrawerKanbanSectionFormArea
};

export { GlobalStyledComponents };